import { render, staticRenderFns } from "./musicMetaData.vue?vue&type=template&id=4f9f4ea3&scoped=true"
import script from "./musicMetaData.vue?vue&type=script&lang=js"
export * from "./musicMetaData.vue?vue&type=script&lang=js"
import style0 from "./musicMetaData.vue?vue&type=style&index=0&id=4f9f4ea3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9f4ea3",
  null
  
)

export default component.exports